"use strict";
import deprecatedStyled from "lib/styled-components";
import { UniverseChainId } from "uniswap/src/types/chains";
const StyledParagraph = deprecatedStyled.p`
  padding: 16px;
  border-radius: 16px;
  font-size: 1.1em;
  background-color: ${({ theme }) => theme.critical2};
`;
const ZERO_NOTICE = {
  message: "Support for Zero Mainnet will be available until July 31st. Read more at:",
  linkHref: "https://x.com/zerodotnetwork/status/2057529610628128917",
  linkText: "https://x.com/zerodotnetwork/status/205...917"
};
const ABSTRACT_NOTICE = {
  message: "Abstract is winding down on December 15, 2026. This interface will be discontinued on that date. Please withdraw or move your funds before then.",
  linkHref: "https://x.com/AbstractChain/status/2107554632675340420",
  linkText: "Read the official announcement \u2192"
};
const SUNSET_NOTICES = {
  [UniverseChainId.Zero]: ZERO_NOTICE,
  [UniverseChainId.AbstractMainnet]: ABSTRACT_NOTICE,
  [UniverseChainId.AbstractTestnet]: ABSTRACT_NOTICE
};
export function hasSunsetNotice(chainId) {
  return chainId !== void 0 && chainId in SUNSET_NOTICES;
}
export function DeprecationWarningBanner({ chainId }) {
  const notice = chainId !== void 0 ? SUNSET_NOTICES[chainId] : void 0;
  if (!notice) {
    return null;
  }
  return <StyledParagraph>
    {notice.message}
    {" "}
    <a href={notice.linkHref}>{notice.linkText}</a>
  </StyledParagraph>;
}
